import {Map} from '../../utils/immutable'
import {PaymentsState, PaymentsStateMap} from './types'

export const initialState: PaymentsStateMap = Map<PaymentsState>({})
